module.exports = __webpack_public_path__ + "assets/img/指导.bc369844.jpg";